// @flow
import * as React from 'react';
import { Box, IconButton, Menu, MenuItem, SxProps, Typography } from '@mui/material';
import { DotsThreeVertical, PencilSimple, Trash } from '@phosphor-icons/react';

type DescriptionProps = {
  icon: React.ReactNode;
  title: string;
  subtitle?: string | null;
};

type Props = DescriptionProps & {
  content?: React.ReactNode;
  onEditClick?: () => void;
  onDeleteClick: () => void;
  sx?: SxProps;
};

export function DoctorsDrugsItem(props: Props) {
  return (
    <Box sx={{
      display: 'flex',
      alignItems: { md: 'center' },
      gap: 2,
      justifyContent: 'space-between',
      flexDirection: {xs: 'column', md: 'row'}, p: 2, ...(props.sx || {})}} className={'doctors-drugs-item'} data-test={'doctors-drugs-item'}>

      <Box sx={{display: 'flex', alignItems: 'center', gap: 2, flex: 1}}>
        <DoctorsDrugsItemDescription {...props} />
        <ActionMenu onDeleteClick={props.onDeleteClick} onEditClick={() => props.onEditClick && props.onEditClick()} />
      </Box>

      {props.content}

      <Box sx={{gap: 1, alignItems: 'center', display: {xs: 'none', md: 'flex'} }}>
        <IconButton sx={{opacity: props.onEditClick ? 1 : 0, pointerEvents: props.onEditClick ? 'all' : 'none'}} onClick={props.onEditClick}>
          <PencilSimple size={24} color={'#1C434F'} />
        </IconButton>
        <IconButton onClick={props.onDeleteClick}>
          <Trash size={24} color={'#1C434F'} />
        </IconButton>
      </Box>
    </Box>
  );
}

const ActionMenu = ({onDeleteClick, onEditClick}: {onEditClick: () => void, onDeleteClick: () => void}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return <>
    <IconButton onClick={handleClick} sx={{alignSelf: 'flex-start', display: {xs: 'block', md: 'none'}}}>
      <DotsThreeVertical size={22} color={'#1C434F'} weight={'bold'} />
    </IconButton>
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
      transformOrigin={{vertical: 'top', horizontal: 'right'}}
      open={open}
      onClose={handleClose}
    >
      <MenuItem onClick={() => {
        handleClose();
        onEditClick();
      }}>Edit</MenuItem>
      <MenuItem onClick={() => {
        handleClose();
        onDeleteClick();
      }}>Delete</MenuItem>
    </Menu>
  </>
}

export function DoctorsDrugsItemDescription(props: DescriptionProps) {
  return (
    <Box sx={{display: 'flex', gap: 1.5, alignItems: 'center', flex: 1}}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#E0F0F5',
          borderRadius: '8px',
          minWidth: 48,
          width: 48,
          height: 48,
        }}
      >
        {props.icon}
      </Box>
      <div>
        <Typography><b>{props.title}</b></Typography>
        {props.subtitle && <Typography variant={'body2'} color={'text.secondary'}>{props.subtitle}</Typography>}
      </div>
    </Box>
  );
}
